import {numeric, required} from "@vuelidate/validators";

const regularValidation = {
    company_name: {
        required
    },
    investment_name: {
        required
    },
    start_date: {
        required
    },
    end_date: {
        required
    },
    users: {
        required,
        minLength: 1
    },
    billing_type: {
        required
    },
    investment_description: {},
    active: {},
    email: {},
    email_cc: {},
    subject: {},
    message: {},
    report_confirmation_email: {},
    report_confirmation_email_cc: {},
    report_confirmation_subject: {},
    report_confirmation_message: {}
};

const INVESTMENT_VALIDATION = {
    CHANGEABLE_PRICE_TYPE: {
        ...regularValidation,
        inv_basic_price: {
            required,
            numeric
        },
        inv_discount_spot: {
            required,
            numeric
        }
    },
    CONST_PRICE_TYPE: {
        ...regularValidation
    }
};

export { INVESTMENT_VALIDATION };
